export default "__VITE_ASSET__DsFXGxjy__"